import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import GitHubCalendar from "react-github-calendar";
import myImg from "../../Assets/avatar.svg";
import LicenseSection from "./LicenseSection";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { CgCPlusPlus } from "react-icons/cg";

import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiGit,
  DiPython,
} from "react-icons/di";

import {
  SiPhp,
  SiCodeigniter,
  SiLaravel,
  SiNextdotjs,
  SiTailwindcss,
  SiBootstrap,
  SiMysql,
  SiPostgresql,
  SiFirebase,
  SiFlutter,
  SiTensorflow,
  SiScikitlearn,
} from "react-icons/si";

import {
  SiVisualstudiocode,
  SiPostman,
  SiGithub,
  SiFigma,
  SiJupyter,
  SiGooglecolab,
  SiMicrosoftexcel,
  SiMicrosoftpowerpoint,
} from "react-icons/si";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple">INTRODUCE</span> MYSELF
            </h1>

            <p className="home-about-body">
              Hello! I'm <b className="purple">Reza Ananda Pandia</b>, a
              passionate <b className="purple">Full Stack Web Developer</b> and{" "}
              <b className="purple">Bachelor Computer Science</b> who enjoys
              transforming ideas into impactful digital solutions.
              <br />
              <br />
              Throughout my academic journey and professional internships, I
              have developed various applications ranging from{" "}
              <b className="purple">web-based information systems</b>,{" "}
              <b className="purple">GIS applications</b>,{" "}
              <b className="purple">Machine Learning solutions</b>, to{" "}
              <b className="purple">IoT monitoring systems</b>.
              <br />
              <br />
              My primary expertise includes{" "}
              <b className="purple">
                PHP, JavaScript, Python, C++, Java, and Dart (Flutter)
              </b>
              , along with modern web technologies such as{" "}
              <b className="purple">
                CodeIgniter 4, Laravel, React.js, Next.js, Tailwind CSS,
                Bootstrap, MySQL, PostgreSQL, and Git
              </b>
              .
              <br />
              <br />I also have a strong interest in{" "}
              <b className="purple">
                Artificial Intelligence, Machine Learning, Natural Language
                Processing (NLP), and Data Analysis
              </b>
              , where I have built several projects using{" "}
              <b className="purple">
                Python, Scikit-learn, XGBoost, Random Forest, and TensorFlow
              </b>
              .
              <br />
              <br />I believe that technology is not only about writing code,
              but also about creating solutions that improve efficiency, solve
              real-world problems, and deliver meaningful value. I am always
              eager to{" "}
              <b className="purple">
                learn, collaborate, and continuously grow as a Software
                Engineer.
              </b>
            </p>
          </Col>

          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>

        <LicenseSection />

        {/* My Skill Set */}
        <Row
          style={{
            justifyContent: "center",
            paddingBottom: "50px",
            color: "#fff",
          }}
        >
          <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
            My <strong className="purple">SkillSet</strong>
          </h1>
          {/* Programming Languages */}
          <Col xs={4} md={2} className="tech-icons">
            <SiPhp title="PHP" />
          </Col>

          <Col xs={4} md={2} className="tech-icons">
            <DiJavascript1 title="JavaScript" />
          </Col>

          <Col xs={4} md={2} className="tech-icons">
            <DiPython title="Python" />
          </Col>

          <Col xs={4} md={2} className="tech-icons">
            <CgCPlusPlus title="C++" />
          </Col>

          {/* Framework */}
          <Col xs={4} md={2} className="tech-icons">
            <SiCodeigniter title="CodeIgniter 4" />
          </Col>

          <Col xs={4} md={2} className="tech-icons">
            <SiLaravel title="Laravel" />
          </Col>

          <Col xs={4} md={2} className="tech-icons">
            <DiReact title="React.js" />
          </Col>

          <Col xs={4} md={2} className="tech-icons">
            <SiNextdotjs title="Next.js" />
          </Col>

          {/* Backend */}
          <Col xs={4} md={2} className="tech-icons">
            <DiNodejs title="Node.js" />
          </Col>

          {/* CSS */}
          <Col xs={4} md={2} className="tech-icons">
            <SiTailwindcss title="Tailwind CSS" />
          </Col>

          <Col xs={4} md={2} className="tech-icons">
            <SiBootstrap title="Bootstrap" />
          </Col>

          {/* Database */}
          <Col xs={4} md={2} className="tech-icons">
            <SiMysql title="MySQL" />
          </Col>

          <Col xs={4} md={2} className="tech-icons">
            <SiPostgresql title="PostgreSQL" />
          </Col>

          <Col xs={4} md={2} className="tech-icons">
            <SiFirebase title="Firebase" />
          </Col>

          {/* Mobile */}
          <Col xs={4} md={2} className="tech-icons">
            <SiFlutter title="Flutter" />
          </Col>

          {/* AI / ML */}
          <Col xs={4} md={2} className="tech-icons">
            <SiTensorflow title="TensorFlow" />
          </Col>

          <Col xs={4} md={2} className="tech-icons">
            <SiScikitlearn title="Scikit-learn" />
          </Col>

          {/* Version Control */}
          <Col xs={4} md={2} className="tech-icons">
            <DiGit title="Git" />
          </Col>
        </Row>

        {/* Tools I use */}
        <Row
          style={{
            justifyContent: "center",
            paddingBottom: "50px",
            color: "#fff",
          }}
        >
          <h1 className="project-heading">
            <strong className="purple">Tools</strong> I use
          </h1>
          <Col xs={4} md={2} className="tech-icons">
            <SiVisualstudiocode title="Visual Studio Code" />
          </Col>

          {/* API */}
          <Col xs={4} md={2} className="tech-icons">
            <SiPostman title="Postman" />
          </Col>

          {/* Version Control */}
          <Col xs={4} md={2} className="tech-icons">
            <SiGithub title="GitHub" />
          </Col>

          {/* UI Design */}
          <Col xs={4} md={2} className="tech-icons">
            <SiFigma title="Figma" />
          </Col>

          {/* AI */}
          <Col xs={4} md={2} className="tech-icons">
            <SiJupyter title="Jupyter Notebook" />
          </Col>

          <Col xs={4} md={2} className="tech-icons">
            <SiGooglecolab title="Google Colab" />
          </Col>

          {/* Productivity */}
          <Col xs={4} md={2} className="tech-icons">
            <SiMicrosoftexcel title="Microsoft Excel" />
          </Col>

          <Col xs={4} md={2} className="tech-icons">
            <SiMicrosoftpowerpoint title="Microsoft PowerPoint" />
          </Col>
        </Row>

        {/* Days | Code */}
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
            Days I <strong className="purple">Code</strong>
          </h1>
          <GitHubCalendar
            username="Rezaananda28"
            blockSize={15}
            blockMargin={5}
            color="#c084f5"
            fontSize={16}
          />
        </Row>

        {/* Find Me On */}
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Rezaananda28"
                  style={{ color: "white" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/reza-ananda-pandia28/"
                  style={{ color: "white" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/rezaannda_"
                  style={{ color: "white" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
